exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\r\n  background-color: #3d1951;\r\n  padding: 10px;\r\n  margin: 0 auto;\r\n  height: auto;\r\n  width: 100%;\r\n  padding: 24px;\r\n}\r\n\r\nh4 {\r\n  color: #ffffff;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main